import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'h3-decision-message-modal',
  templateUrl: './decision-message-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DecisionMessageModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      title: string;
      text: string;
    },
    private dialogRef: MatDialogRef<DecisionMessageModalComponent>,
  ) {}

  confirm() {
    this.dialogRef.close(true);
  }
}
